import React from 'react';
import {DownloadButton} from '../../../../common/Form/Button/Button';
import {StatusTag} from '../../../../common/Styled/Styled.styles';
import {Container, Details, Remarks, SystemRemarks} from './TrackGstInput.styles';

const TrackGstInput = ({data, dataArray}) => {
  const {
    refId,
    walletRefId,
    remarks,
    systemRemarks,
    startMonth,
    endMonth,
    status,
    invoiceUrl,
  } = data;

  const handleDownloadInvoice = () => {
    window.open(invoiceUrl, '_blank');
  };

  return (
    <Container>
      <div className="flex hCenter">
        <p>
          <span className="fs18 latoBlack blackText">
            {startMonth} {startMonth && `- ${endMonth}`}
          </span>
        </p>
        {status && (
          <StatusTag className="ml5" status={status}>
            {status}
          </StatusTag>
        )}
      </div>
      <Details>
        <li>
          <span>Reference ID</span>
          <span>{refId}</span>
        </li>
        <li>
          <span>Invoice Amount</span>
          <span>{dataArray[2]?.label}</span>
        </li>
        <li>
          <span>Submitted On</span>
          <span>{dataArray[1]?.label}</span>
        </li>
        <li>
          <span>Processed Date</span>
          <span>{dataArray[4]?.label}</span>
        </li>
        <li>
          <span>GST Credit Amount</span>
          <span>{dataArray[3]?.label}</span>
        </li>
        <li>
          <span>Wallet Recharge ID</span>
          <span>{walletRefId}</span>
        </li>
      </Details>
      {remarks && (
        <Remarks>
          <p className="fs12">Remarks</p>
          <p className="fs16 latoBlack blackText mt5">{remarks}</p>
        </Remarks>
      )}
      {systemRemarks && (
        <SystemRemarks>
          <p className="fs12">System Remarks</p>
          <p className="fs16 latoBlack blackText mt5">{systemRemarks}</p>
        </SystemRemarks>
      )}
      <div className="mt15">
        <DownloadButton isActive={true} onClick={handleDownloadInvoice}>
          Download Invoice
        </DownloadButton>
      </div>
    </Container>
  );
};

export default TrackGstInput;
